module.exports = __webpack_public_path__ + "img/logo.01a0eef6.svg";